module.exports = __webpack_public_path__ + "static/img/xuebi_18.7ded2179.png";